export default "__VITE_ASSET__B$KAU5FT__"